import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Subject } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { PledgeRead } from '../../definition/interface/Pledge';

@Component({
    selector: 'phone-form',
    templateUrl: './phone-form.component.html',
    styleUrls: ['./phone-form.component.scss'],
    standalone: false
})
export class PhoneFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  subscriptions: any[] = [];
  countries: any[];
  departments: any[];
  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;
  cristalisOrganizationId: number = 251251251;
  isCristalisOrganization: boolean;
  sessionConsultant: boolean;
  pledge: PledgeRead;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
    private attributionDao: AttributionDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade?.getPledge();
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
    });
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this, {
      sessionConsultant: this.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
    });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
